<template>
  <b-row id="repairDetail">
    <b-col class="col-8">
      <Left :detailInfo="detailInfo"></Left>
    </b-col>
    <b-col class="col-4">
      <Right :detailInfo="detailInfo" @initDetailInfo="initDetailInfo"></Right>
    </b-col>
  </b-row>
</template>

<script>
import Left from "./children/LeftInfo.vue";
import Right from "./children/RightInfo.vue";
import { getRepairDetail } from "@/service/index";

export default {
  data() {
    return {
      detailInfo: {},
    };
  },
  mounted() {
    this.initDetailInfo();
  },
  methods: {
    initDetailInfo() {
      let d_id = this.$route.params.id;
      getRepairDetail(d_id).then((res) => {
        if (res && res.payload) {
          this.detailInfo = res.payload;
        }
      });
    },
  },
  components: {
    Left,
    Right,
  },
};
</script>

<style scoped lang="scss">
#repairDetail {
  flex: 1;
  font-size: 14px;
}
</style>
